<template>
  <v-text-field v-model="showColor" :label="label" hide-details>
    <template v-slot:prepend>
      <v-menu
        v-model="menu"
        top
        lav
        nudge-bottom="105"
        nudge-left="16"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <div :style="swatchStyle" v-on="on" />
        </template>
        <v-color-picker
          v-model="color"
          hide-mode-switch
          :mode="type == 'hex' ? 'hexa' : type"
        />
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "InputColorHex",
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    menu: false,
    types: ["hex", "rgba", "hexa"],
    hex: "       ",
    hexa: "         ",
    rgba: { r: 255, g: 0, b: 255, a: 1 },
  }),
  computed: {
    color: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },
    showColor: {
      get() {
        if (typeof this.color === "string") {
          this.$emit("input", this.color);
          return this.color;
        } else {
          this.$emit("input", null);

          return null;
        }
      },
      set(v) {
        this[this.type] = v;
      },
    },
    swatchStyle: {
      get() {
        const { color, menu } = this;
        return {
          backgroundColor: color,
          cursor: "pointer",
          height: "30px",
          width: "30px",
          borderRadius: menu ? "50%" : "4px",
          transition: "border-radius 200ms ease-in-out",
          border: "solid 1px gray",
        };
      },
      set(v) {
        return v;
      },
    },
  },
  watch: {
    value: function () {
      if (this.value) {
        this.color = this.value;
      }
    },
  },
  mounted() {
    if (this.value) {
      this.color = this.value;
    }
  },
};
</script>
